import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useBilling } from "../context/BillingContext";

export default function Pricing() {
  const navigate = useNavigate();
  const { openUpgrade, closeUpgrade, upgradeModal } = useBilling();
  const [params] = useSearchParams();
  const openedOnce = useRef(false);

  // Open once on mount
  useEffect(() => {
    if (!openedOnce.current) {
      openedOnce.current = true;
      openUpgrade(params.get("canceled") ? "checkout_canceled" : null);
    }
  }, [openUpgrade, params]);

  // Once modal closes (after we opened it), bounce back to dashboard
  useEffect(() => {
    if (openedOnce.current && !upgradeModal.open) {
      const t = setTimeout(() => navigate("/dashboard", { replace: true }), 50);
      return () => clearTimeout(t);
    }
  }, [upgradeModal.open, navigate]);

  // Cleanup: ensure modal is closed if user navigates away
  useEffect(() => () => closeUpgrade(), [closeUpgrade]);

  return <div className="min-h-screen bg-champagne" />;
}
